const dessert = [
    {
        id: 1,
        name: 'Bolo de Limão',
        description: 'fermento, açucar, farinha, limão',
        price: '1.500'
    },
    {
        id: 2,
        name: 'Salada de fruta',
        description: 'morangos, banana, abacate, melancia',
        price: '2.000'
    },
    {
        id: 3,
        name: 'Pudim de maracujá',
        description: 'leite, açucar, maracujá',
        price: '2.000'
    }
];

export default dessert;